import { call, select, takeEvery, StrictEffect } from 'redux-saga/effects';
import { RootState } from '../RootState';
import { UserActions } from '../actions/user';
import { logOnOff } from '../../lib/api/logOnOff';

export function* logInSaga(): Generator<StrictEffect> {
    yield takeEvery(UserActions.logOnOff, function* ({ payload: shouldLogOn }) {
        const isLoggedOn = yield select((s: RootState) => s.user.isLoggedOn);

        if (shouldLogOn === isLoggedOn) {
            console.warn(
                shouldLogOn
                    ? 'Not attempting log in - user is already logged in'
                    : 'Not attempting log out - user is not logged in',
            );
            return;
        }
        const redirectUrl = yield call(() => logOnOff());

        window.location.replace(redirectUrl);
    });
}
